module.exports = __webpack_public_path__ + "media/images/sites/health/bg-contact-b9d517f0a1a7c3de37798ff544c86d72.jpg";